export async function removeEmptyObjectsFromFilter(data: any) {
  const paginationReceived = data.pagination
  const filterReceived = data.filter

  const newFilters: any = {}
  if (filterReceived) {
    for (const [key, value] of Object.entries(filterReceived)) {
      if (filterReceived[key] != undefined && filterReceived[key] != null) {
        if (filterReceived[key].constructor == Array) {
          if (filterReceived[key].length != 0) {
            newFilters[key] = value
          }
        } else {
          newFilters[key] = value
        }
      }
    }
  }

  const newData: any = {}

  if (paginationReceived) {
    if (Object.keys(paginationReceived).length !== 0) {
      newData.pagination = paginationReceived
    }
  }
  if (filterReceived) {
    if (Object.keys(newFilters).length !== 0) {
      newData.filter = newFilters
    }
  }

  return newData
}
